import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

// Async thunk to fetch user bank details
export const fetchBankDetails = createAsyncThunk(
  'bank/fetchBankDetails',
  async (email, { rejectWithValue }) => {
    try {
      // Get document from bankInfo collection using email as document ID
      const bankDocRef = doc(db, 'bankInfo', email);
      const bankDocSnap = await getDoc(bankDocRef);
      
      if (bankDocSnap.exists()) {
        return {
          id: bankDocSnap.id,
          ...bankDocSnap.data()
        };
      } else {
        // Return empty bank details if document doesn't exist
        return {
          id: email,
          bankType: 'uk',
          accountName: '',
          accountNumber: '',
          bankName: '',
          branchName: '',
          routingNumber: '',
          swiftCode: '',
          sortCode: '',
          iban: ''
        };
      }
    } catch (error) {
      console.error('Error fetching bank details:', error);
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to update user bank details
export const updateBankDetails = createAsyncThunk(
  'bank/updateBankDetails',
  async (bankData, { rejectWithValue }) => {
    try {
      const { id, ...bankDetails } = bankData;
      // Update or create the document in bankInfo collection
      await setDoc(doc(db, 'bankInfo', id), bankDetails, { merge: true });
      
      return bankData;
    } catch (error) {
      console.error('Error updating bank details:', error);
      return rejectWithValue(error.message);
    }
  }
);

const bankSlice = createSlice({
  name: 'bank',
  initialState: {
    details: null,
    loading: false,
    updating: false,
    error: null
  },
  reducers: {
    clearBankDetails: (state) => {
      state.details = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch bank details reducers
      .addCase(fetchBankDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBankDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(fetchBankDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update bank details reducers
      .addCase(updateBankDetails.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateBankDetails.fulfilled, (state, action) => {
        state.updating = false;
        state.details = action.payload;
      })
      .addCase(updateBankDetails.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      });
  }
});

export const { clearBankDetails } = bankSlice.actions;
export default bankSlice.reducer; 